export default __webpack_public_path__ + "locales/ru/DataReassignmentDialog.json?hash=25516631776af084d4d2372a34726f99";